import { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';

export default function LoadingComponent({ variant = 'brand-dark', size = 'md', text = '', mode = 'none', className = '' }) {
  const [loadingText, setLoadingText] = useState(text);

  const modes = {
    none: 'text-center center',
    override: 'd-flex flex-column align-content-center justify-content-center text-center center absolute-full',
    fullscreen: 'd-flex flex-column align-content-center justify-content-center text-center center absolute-full loading-fullscreen',
  };

  const backgroundClasses = `${className} ${modes[mode] || modes.none}`;

  useEffect(() => {
    if (size || !text) {
      return;
    }

    const timeout = setTimeout(() => {
      if (loadingText === text + '...') {
        setLoadingText(text);
        return;
      }

      setLoadingText(loadingText + '.');
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  });

  return (
    <div className={backgroundClasses}>
      <div className="">
        {loadingText && <div><h1 className={ `mb-0 fw-bold text-${variant}` }>{loadingText}</h1></div>}
        {size && <Spinner animation="border" className={ `${loadingText ? 'mt-3' : 'mt-0'} spinner-border-${ size } border-color-${ variant }`} variant={variant} />}
      </div>
      {mode == 'fullscreen' && (
        <style>
          {`
            html {
              position: relative;
            }

            html, body {
              overflow: hidden;
              position: static;
            }
          `}
        </style>
      )}
    </div>
  );
}
